import React from 'react';
import FormInput from './FormInput';

const StudentInfoForm = ({ 
  formData, 
  setFormData, 
  errors, 
  countries, 
  filieres, 
  niveaux, 
  classes, 
  fetchNiveauxByFiliere, 
  fetchClasses, 
  handleInputChange 
}) => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
      <FormInput
        label="Matricule"
        name="matricule"
        value={formData.matricule}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        error={errors.matricule}
      />
      <FormInput
        label="Nom"
        name="nom"
        value={formData.nom}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        required
        error={errors.nom}
      />
      <FormInput
        label="Prénom"
        name="prenom"
        value={formData.prenom}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        required
        error={errors.prenom}
      />
      <FormInput
        label="Genre"
        name="genre"
        value={formData.genre}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        type="select"
        options={[
          { value: '', label: 'Sélectionner un genre' },
          { value: 'M', label: 'Masculin' },
          { value: 'F', label: 'Féminin' }
        ]}
        required
        error={errors.genre}
      />
      <FormInput
        label="Date de naissance"
        name="date_naissance"
        value={formData.date_naissance}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        type="date"
        required
        error={errors.date_naissance}
      />
      <FormInput
        label="Lieu de naissance"
        name="lieu_naissance"
        value={formData.lieu_naissance}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        required
        error={errors.lieu_naissance}
      />
      <FormInput
        label="Nationalité"
        name="nationalite"
        value={formData.nationalite}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        type="select"
        options={[
          { value: '', label: 'Sélectionner une nationalité' },
          ...countries
        ]}
        required
        error={errors.nationalite}
      />
      <FormInput
        label="Contact"
        name="contact"
        value={formData.contact}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        required
        error={errors.contact}
      />
      <FormInput
        label="Email"
        name="email"
        value={formData.email}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        type="email"
      />
      <FormInput
        label="Adresse"
        name="adresse"
        value={formData.adresse}
        onChange={(e) => {
          const { name, value } = e.target;
          setFormData(prev => ({
            ...prev,
            [name]: value
          }));
        }}
        required
        className="md:col-span-2"
        error={errors.adresse}
      />
      <FormInput
        label="Filière"
        name="filiere"
        value={formData.filiere}
        onChange={(e) => {
          const { value } = e.target;
          setFormData(prev => ({
            ...prev,
            filiere: value,
            niveau: '', // Reset niveau when filiere changes
            classe: '' // Reset classe when filiere changes
          }));
          if (value) {
            fetchNiveauxByFiliere(value);
          }
        }}
        type="select"
        options={[
          { value: '', label: 'Sélectionner une filière' },
          ...filieres.map(f => ({ value: f.id, label: f.libelle }))
        ]}
        required
        error={errors.filiere}
      />
      <FormInput
        label="Niveau"
        name="niveau"
        value={formData.niveau}
        onChange={(e) => {
          const { value } = e.target;
          setFormData(prev => ({
            ...prev,
            niveau: value,
            classe: '' // Reset classe when niveau changes
          }));
          if (value && formData.filiere) {
            fetchClasses(value, formData.filiere);
          }
        }}
        type="select"
        options={[
          { value: '', label: 'Sélectionner un niveau' },
          ...niveaux.map(n => ({ value: n.id, label: n.libelle }))
        ]}
        required
        error={errors.niveau}
        disabled={!formData.filiere}
      />
      <FormInput
        label="Classe"
        name="classe"
        value={formData.classe}
        onChange={handleInputChange}
        type="select"
        options={[
          { value: '', label: 'Sélectionner une classe' },
          ...classes.map(c => ({ value: c.id, label: c.libelle }))
        ]}
        required
        error={errors.classe}
        disabled={!formData.niveau || !formData.filiere}
      />
    </div>
  );
};

export default StudentInfoForm;
